<template>
  <div>
    <div v-if="attachments.length > 1" class="attachments_count">
      <span>{{ currentSlideIndex + 1 }}/{{ attachments.length }}</span>
    </div>
    <div class="post-media-slider">
      <div v-for="(item, index) in attachments" :key="index">
        <div v-if="item.type == attachmentType.VIDEO || item.type == attachmentType.GIF_IMAGE" class="sliderelement">
          
          <MediaPlayer
            :slideID="index"
            :activeVideoIndex="currentSlideIndex"
            :postID="postID"
            :attachmentID="item.id"
            :extension="item.extension"
            :hash="item.url_path_hash"
            :hls_path="item.hls_path"
            :thumbExtension="item.thumb_extension"
            :thumbHash="item.thumb_path_hash"
            @showVideoPopup_event="showPopUp_video($event)"
            @is_media_clicked="$emit('is_media_clicked', $event);"
            
          />
        </div>
        <div v-if="item.type == attachmentType.AUDIO">
          <AudioPlayer
            :slideId="index"
            :postID="postID"
            :attachments="attachments"
            :attachmentID="item.id"
            :extension="item.extension"
            :hash="item.url_path_hash"
            :hls_path="item.hls_path"
            :thumbExtension="item.thumb_extension"
            :thumbHash="item.thumb_path_hash"
            @click.native="$emit('is_media_clicked', $event);"
            @touchstart.native="$emit('is_media_clicked', $event);"
          />
        </div>
        <div v-if="item.type == attachmentType.IMAGE" class="sliderelement">
          <PostImage
            :postID="postID"
            :attachmentID="item.id"
            :extension="item.extension"
            :hash="item.url_path_hash"
            @click.native="$emit('is_media_clicked', $event);"
            @touchstart.native="$emit('is_media_clicked', $event);"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import MediaPlayer from "./media-player.vue";
import AudioPlayer from "./audio-player.vue"
import PostImage from "./post-image.vue";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import jQuery from "jquery";
import "slick-carousel/slick/slick.min.js";
import ReRenderer from "../../mixins/re-renderer.vue";
import { AttachmentType } from "./enums.js";

export default {
  mixins: [ReRenderer],
  name: "MediaSlider",
  components: {
    MediaPlayer: MediaPlayer,
    AudioPlayer: AudioPlayer,
    PostImage: PostImage,
  },
  data() {
    return {
      reRenderCssSelectors: [
        {
          jquerySelectors: ".post-media-slider",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
      currentSlideIndex: 0,
      slider: null,
    };
  },
  props: {
    attachments: {
      type: Array,
    },
    postID: {
      type: String,
    },
    continue_video: {
      type: Boolean,
    },
    left_arrow: {
      default: require("../../assets/left_arrow.svg"),
    },
    right_arrow: {
      default: require("../../assets/right_arrow.svg"),
    },
  },
  computed:{
    attachmentType(){
      return AttachmentType; 
    },
  },
  methods: {
    showPopUp(value) {
      this.$emit("showpopup", value);
    },
    showPopUp_video(value) {
      this.$emit("showVideoPopup_event", value);
    },
    setSlideIndex(event, slick, currentSlide) {
      console.log(event, slick);
      this.currentSlideIndex = currentSlide;
    },
    storeAttachmentsHashes() {
      // Add HLS hashes to the store to use them in "videojs.Vhs.xhr.beforeRequest"
      var attachmentsHashes = new Map();
      this.attachments.forEach((att) => {
        attachmentsHashes.set(att.id, att.url_path_hash);
      });
      this.$store.dispatch(
        "shares/setAttachementsHashes_Action",
        attachmentsHashes
      );
    },
    listenToBeforeRequestEvent() {
      this.storeAttachmentsHashes();
      videojs.Vhs.xhr.beforeRequest = (options) => {
        // If the link is the master link then do not attach additional path hash and return 1
        // Example : https://d291jtucvk86d1.cloudfront.net/posts/95003249273/3.mp4/trans/master.m3u8?h=a9cf23898105bef29c888853bcfa406b
        if (options.uri.includes("master")) return;
        var attachment_id = options.uri.split("/")[5].split(".")[0];
        var attachmentsHashs =
          this.$store.getters["shares/getAttachmentsHashs"];
        var url_hash = attachmentsHashs.get(parseInt(attachment_id));
        options.uri = options.uri + "?h=" + url_hash;
      };
    },
  },
  mounted() {
    this.storeAttachmentsHashes();
    this.listenToBeforeRequestEvent();
    this.slider = jQuery(".post-media-slider").slick({
      arrows: true,
      prevArrow:
        "<img class='a-left control-c prev slick-prev' src='" +
        this.left_arrow +
        "'>",
      nextArrow:
        "<img class='a-right control-c next slick-next' src='" +
        this.right_arrow +
        "'>",
    });

    this.slider.on("afterChange", this.setSlideIndex);
  },
};
</script>

<style scoped>
.your-class {
  /* height: 100% !important;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  height: 100%; */
  /* top: 50%;
      position: relative; */
}
.slick-slider,
.slick-track,
.draggable,
.slick-slide,
.slick-current,
.slick-active,
.slick-list {
  /* height: 100% !important; */
}

.sliderelement {
  /* height: 100% !important;
  position: relative; */
}

.attachments_count {
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  right: 0.5rem;
  row-gap: 1rem;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 100;
  border-radius: 40px;
  width: auto;
  border-radius: 21px;
  min-width: 64px;
}

.attachments_count span {
  font-family: SFUIDisplay;
  font-size: 1.375rem;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}


@media only screen and (max-height: 500px) {
  .attachments_count{
    top:2.5rem !important ;

  }
}



@media only screen and (min-width: 50px) {
  .attachments_count {
    right: 1rem;
    top: 12%;
    min-width: 40px;
  }
  .attachments_count span {
    font-size: 0.85rem;
  }
}
@media only screen and (min-width: 300px) {
  .attachments_count {
    right: 1rem;
    top: 12%;
    min-width: 40px;
  }
  .attachments_count span {
    font-size: 1rem;
  }
}

@media only screen and (min-width: 650px) {
  .attachments_count {
    right: 1.3rem;
    top: 17%;
    min-width: 45px;
  }
  .attachments_count span {
    font-size: 1rem;
  }
}
@media only screen and (min-width: 650px) and (max-height: 550px) {
  /* Size for samsung fold- dual screen mode */
  .attachments_count {
    right: 1.5rem;
    top: 19.5%;
    min-width: 40px;
  }
}
@media only screen and (min-width: 800px) {
  .attachments_count {
    right: 1.4rem;
    top: 14%;
    min-width: 50px;
  }
  .attachments_count span {
    font-size: 1.2rem;
  }
}
@media only screen and (max-height: 650px) and (min-width: 800px) {
  .attachments_count {
    right: 1rem;
    top: 4%;
  }
}
@media only screen and (min-height: 1024px) {
  .attachments_count {
    right: 1.4rem;
    top: 12%;
  }
}
</style>

<style>
.slick-next {
  height: unset !important;
  right: -45px !important;
}

.slick-prev {
  height: unset !important;
  left: -45px !important;
}
.header {
    display: inline-flex;
    align-items: baseline;
    flex-direction: column;
    position: absolute;
    left: 0.5rem;
    top: 5rem;
    gap: 1rem;
    width: 80%;
  }
.header_with_banner{
    display: inline-flex;
    align-items: baseline;
    flex-direction: column;
    position: absolute;
    left: 0.5rem;
    top: 14rem;
    gap: 1rem;
    width: 80%;
  }
.volume-with-banner{
  position: absolute;
  z-index: 1;
  top: 9rem;
  right: 1rem;
  padding: 0;
  margin: 0;
}
.volume-without-banner {
  position: absolute;
  z-index: 1;
  top: 1rem;
  right: 1rem;
  padding: 0;
  margin: 0;
}
.volume-without-banner img {
  width: 2rem;
}
/*Mobile Query*/
@media only screen and (max-width: 677px) {
  .slick-next,
  .slick-prev {
    display: none !important;
  }
}
@media only screen and (max-width: 768px) {
  .volume-with-banner{
    top: 8rem;
  }
}
</style>